/**
 * @generated SignedSource<<05cb6364a0108c3f683fdbb6d12e3969>>
 * @relayHash 826d8bbf65d33d2926a161a6bc40b798
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 358f6962780c4d7af632e774a57f08a426df90d6cd01ba5fedfeb9b93cbd5043

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useConfluenceAutomationNudgeActionsQuery$variables = {
  contentId: string;
  includeStatusUpdatesAutomation: boolean;
};
export type useConfluenceAutomationNudgeActionsQuery$data = {
  readonly singleContent: {
    readonly __typename: "Content";
    readonly id: string | null;
    readonly statusUpdatesAutomationContent?: {
      readonly " $fragmentSpreads": FragmentRefs<"useStatusUpdatesAutomationNudgeAction_content">;
    } | null;
  } | null;
  readonly user: {
    readonly __typename: "AtlassianUser";
    readonly id: string | null;
    readonly statusUpdatesAutomationUser?: {
      readonly " $fragmentSpreads": FragmentRefs<"useStatusUpdatesAutomationNudgeAction_user">;
    } | null;
  } | null;
};
export type useConfluenceAutomationNudgeActionsQuery = {
  response: useConfluenceAutomationNudgeActionsQuery$data;
  variables: useConfluenceAutomationNudgeActionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeStatusUpdatesAutomation"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "current",
    "value": true
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "title"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v1/*: any*/),
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "condition": "includeStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useStatusUpdatesAutomationNudgeAction_user"
                    }
                  ],
                  "type": "AtlassianUser"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "statusUpdatesAutomationUser"
              }
            ]
          }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "condition": "includeStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "useStatusUpdatesAutomationNudgeAction_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "statusUpdatesAutomationContent"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "selections": [
      {
        "alias": "user",
        "args": (v1/*: any*/),
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "condition": "includeStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "AtlassianUserEmail",
                "kind": "LinkedField",
                "name": "emails",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "condition": "includeStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v5/*: any*/),
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              },
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/)
                ]
              },
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          }
                        ],
                        "type": "KnownUser"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "sourceTemplateEntityId"
                  }
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 25
                  }
                ],
                "concreteType": "PaginatedContentList",
                "kind": "LinkedField",
                "name": "children",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      {
                        "concreteType": "ContentMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "createdDate"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "children(first:25)"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "826d8bbf65d33d2926a161a6bc40b798",
    "id": "358f6962780c4d7af632e774a57f08a426df90d6cd01ba5fedfeb9b93cbd5043",
    "metadata": {},
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "operationKind": "query",
    "text": "query useConfluenceAutomationNudgeActionsQuery($contentId:ID!,$includeStatusUpdatesAutomation:Boolean!){user:confluence_atlassianUser(current:true){__typename,id,...useStatusUpdatesAutomationNudgeAction_user@include(if:$includeStatusUpdatesAutomation)},singleContent(id:$contentId){__typename,id,...useStatusUpdatesAutomationNudgeAction_content@include(if:$includeStatusUpdatesAutomation)}}fragment useStatusUpdatesAutomationNudgeAction_content on Content{id,title,space{id},ancestors{id,title},history{ownedBy{__typename,...on KnownUser{accountId}}},metadata{sourceTemplateEntityId},children(first:25){nodes{id,title,metadata{createdDate}}}}fragment useStatusUpdatesAutomationNudgeAction_user on AtlassianUser{id,emails{value,isPrimary}}"
  }
};
})();

(node as any).hash = "921039da46c43006d3e5ec8e587c711d";

export default node;
